(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("support_chat", [], factory);
	else if(typeof exports === 'object')
		exports["support_chat"] = factory();
	else
		root["support_chat"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 